// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__13yHx","right":"Footer_right__XUzKQ","buttons":"Footer_buttons__pidMl"};